<template>
	<div class="pagination">
		<!-- <button @click="changePageNow(pageNow - 1)" :class="pageNow === 1?'disabled_change':''" :disabled="pageNow === 1">&lt;上一页</button> -->
		<button @click="changePageNow(1)" v-show="startEnd.start !== 1">1</button>
		<span v-show="startEnd.start > 2">···</span>
		<!-- 遍历生成连续页 -->
		<button v-for="(_, index) in (startEnd.end - startEnd.start + 1)" :key="index"
			:class="{ active: (index + startEnd.start === pageNow) }" @click="changePageNow(index + startEnd.start)">
			{{ index + startEnd.start }}
		</button>

		<span v-show="startEnd.end < totalPage - 1">···</span>
		<button @click="changePageNow(totalPage)" v-show="startEnd.end !== totalPage">{{ totalPage }}</button>

		<button :class="pageNow === totalPage ? 'disabled_change' : ''" @click="changePageNow(pageNow + 1)"
			:disabled="pageNow === totalPage">下一页&gt;</button>

		<!-- <span>共 {{ total }} 条</span> -->
	</div>
</template>

<script>
export default {
	name: "Pagination",
	props: ['total', 'pageNow', 'pageSize', 'continues', 'sendPageNow'],
	computed: {
		//计算总页数
		totalPage() {
			return Math.ceil(this.total / this.pageSize)
		},
		//计算连续分页的：起始页、结束页
		startEnd() {
			const { pageNow, continues, totalPage } = this;
			let start = 0
			let end = 0

			if (continues > totalPage) {
				start = 1
				end = totalPage
			} else {
				start = pageNow - parseInt(continues / 2)
				end = pageNow + parseInt(continues / 2)
				if (start < 1) {
					start = 1
					end = continues
				}
				if (end > totalPage) {
					start = totalPage - continues + 1
					end = totalPage
				}
			}
			return { start, end }
		}
	},
	methods: {
		changePageNow(p) {
			// 像父组件传递点击后的页码
			this.sendPageNow(p)
		}
	},
};
</script>

<style lang="stylus" scoped>
.pagination
	margin-bottom 55px
	// text-align center
	
	button 
		padding 0 10px
		height 30px
		line-height 30px
		text-align center
		margin-right 24px
		background-color #F5F5F6
		color #014EA2
		border none
		border-radius 4px
		font-size 13px
		font-family SourceHanSansCN-Medium, SourceHanSansCN
		font-weight 500
		cursor pointer
	.disabled_change
		color #c0c4cc
		cursor not-allowed
	
	span
		display inline-block
		height 30px
		padding 0 10px
		line-height 30px
		text-align center
		margin 0 12px
		background-color #F5F5F6
		color #014EA2
		border none
		border-radius 4px
		font-size 13px
		font-family SourceHanSansCN-Medium, SourceHanSansCN
		font-weight 500
	.active 
		// cursor not-allowed
		background-color #014EA2
		color #fff
    
</style>